import { memo, useMemo } from 'react';
import { Image, Text, Box } from '@bonanza-social/moonlight';
import { NotificationProps } from '../state';
import { NotificationCTA } from '../components';

function Notification({
  imageUrl,
  message,
  actionType,
  promotionId,
  gameId,
  close,
}: NotificationProps) {
  const cleanMessage = useMemo(
    // Remove \n from the end of the string because it interferes with the design system gap between the message and the button
    () => (message ? message.replace(/\n$/, '') : null),
    [message],
  );
  return (
    <Box gap="space-600" alignItems="center" width="100%">
      <Box gap="space-400" width="100%">
        {imageUrl ? (
          <Box>
            <Image
              source={imageUrl}
              borderRadius="radius-400"
              contentFit="contain"
              width="auto"
              height={250}
            />
          </Box>
        ) : null}
        {message ? (
          <Text color="darkSurfacePrimary" variant="body-m">
            {cleanMessage}
          </Text>
        ) : null}
      </Box>
      <NotificationCTA
        actionType={actionType}
        promotionId={promotionId}
        gameId={gameId}
        close={close}
      />
    </Box>
  );
}

export default memo(Notification);
